import ProfilePhotos from "./ProfilePhotos";
export default ProfilePhotos;
